import { createReducer } from '@reduxjs/toolkit'
import { adminActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo Admin
 */
export const adminReducer = createReducer(initialState, (builder) => {
  builder
    // Pending orders count
    .addCase(adminActions.fetchPendingOrdersCountRequest, (state) => {
      state.isLoadingPendingCount = true
      state.pendingCountError = null
    })
    .addCase(adminActions.fetchPendingOrdersCountSuccess, (state, action) => {
      state.isLoadingPendingCount = false
      state.pendingOrdersCount = action.payload.count
    })
    .addCase(adminActions.fetchPendingOrdersCountFailure, (state, action) => {
      state.isLoadingPendingCount = false
      state.pendingCountError = action.payload.error
      state.pendingOrdersCount = null
    })
    
    // Dashboard stats
    .addCase(adminActions.fetchDashboardStatsRequest, (state) => {
      state.isLoadingDashboard = true
      state.dashboardError = null
    })
    .addCase(adminActions.fetchDashboardStatsSuccess, (state, action) => {
      state.isLoadingDashboard = false
      state.dashboardStats = action.payload
    })
    .addCase(adminActions.fetchDashboardStatsFailure, (state, action) => {
      state.isLoadingDashboard = false
      state.dashboardError = action.payload.error
    })
    
    // Clear errors
    .addCase(adminActions.clearPendingCountError, (state) => {
      state.pendingCountError = null
    })
    .addCase(adminActions.clearDashboardError, (state) => {
      state.dashboardError = null
    })
})

